import React from "react";
import PropTypes from "prop-types";
import { RiDeleteBin6Line } from "react-icons/ri";
import QuantityControl from "./QuantityControl";

const CartItemRow = ({ item, onDecrement, onIncrement, onRemove }) => {
  const imageSrc = React.useMemo(() => {
    if (!item.image) return item.defaultImage || "";
    if (Array.isArray(item.image)) return item.image[0];
    if (typeof item.image === "object" && item.selectedColor) {
      return item.image[item.selectedColor]?.[0] || item.defaultImage || "";
    }
    return "";
  }, [item.image, item.selectedColor, item.defaultImage]);

  return (
    <div className="flex gap-5 items-center py-6">
      <div className="w-[110px] max-h-[92px] flex items-center justify-center shrink-0">
        <img
          src={imageSrc}
          alt={item.name}
          className="w-full h-full object-contain drop-shadow-sm"
        />
      </div>

      <div className="flex-1 min-w-0">
        <div className="text-[16px] font-light uppercase tracking-wide text-black flex flex-wrap gap-x-2">
          <span>{item.name},</span>
          {item.selectedColor && <span className="">{item.selectedColor}</span>}
          {item.variant && (
            <span className="text-[#7e7e7e]">/ {item.variant}</span>
          )}
        </div>
        <div className="mt-2 text-[18px] font-light text-black">
          {item.price}
        </div>

        <div className="mt-4 flex items-center gap-4">
          <QuantityControl
            quantity={item.quantity}
            onDecrement={onDecrement}
            onIncrement={onIncrement}
          />

          <button
            type="button"
            aria-label="Remove item"
            onClick={onRemove}
            className="h-10 w-10 flex items-center justify-center text-black/30 hover:text-black/70 transition-colors"
          >
            <RiDeleteBin6Line className="h-6 w-6" />
          </button>
        </div>
      </div>
    </div>
  );
};

CartItemRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    image: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    variant: PropTypes.string,
    selectedColor: PropTypes.string,
    defaultImage: PropTypes.string,
  }).isRequired,
  onDecrement: PropTypes.func.isRequired,
  onIncrement: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default CartItemRow;
